import { NameHelper, filterClasses } from "@swivl-mono/helpers";
import { Channel, UserInterface } from "@swivl-mono/types";
import { Link } from "react-router-dom";

import { ChannelIcons } from "../../../../../Helpers/Conversations/Conversations.Helper";
import { UsersOnlineManager } from "../../../../../Models/Users/UsersOnline.Manager";
import { parseTime } from "./parseTime";

interface ConversationCardProps extends React.HTMLAttributes<HTMLDivElement> {
  user: UserInterface;
  selectedUserId?: number | undefined;
  className?: string;
  isOnline?: boolean;
}

export function ClosedUserCard({ selectedUserId, user, className, isOnline = false, ...rest }: ConversationCardProps) {
  const name = NameHelper.nameForUser(user);
  const ChannelIcon = ChannelIcons[user.lastUserMessageChannel || Channel.WEB];
  const isSelected = user.id === selectedUserId;

  return (
    <Link className="text-black hover:text-black" to={`/contact-center/conversations/user/${user.id}`}>
      <div
        className={filterClasses(
          "group flex h-[58px] w-full items-center gap-4 rounded-lg px-3 transition-colors duration-100 ease-in-out hover:bg-grey-100",
          isSelected ? "bg-grey-50" : "bg-white",
          className
        )}
        {...rest}
      >
        {/* avatar */}
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div className={filterClasses("relative flex size-8 shrink-0 items-center justify-center rounded-full", "bg-grey-300 text-grey-600")}>
            <ChannelIcon size={16} />

            {/* online indicator */}
            <div
              className={filterClasses(
                "absolute right-0 bottom-0 size-2 rounded-full outline-2 transition-all duration-200",
                isSelected ? "outline-grey-50" : "outline-white",
                isOnline || UsersOnlineManager.isConversationFresh(user?.id)
                  ? "border border-teal-500 bg-teal-500"
                  : "border border-grey-600 bg-white"
              )}
            />
          </div>

          {/* customer name */}
          <span className="truncate text-sm font-semibold text-black">{name}</span>
        </div>

        {/* time of last interaction */}
        <p className="text-sm text-grey-600">{parseTime(user.lastInteractionAt)}</p>
      </div>
    </Link>
  );
}
